// components/ui/ZenitThinking.jsx
import React from 'react';
import logoIcon from '../../assets/zenit-thinking-icon.png';

/**
 * Componente de ícono de Zenit con animación de "thinking"
 * Usa el logo real de Zenit con efecto de pulse
 */
const ZenitThinking = ({ size = 24, className = '' }) => {
  return (
    <div 
      className={`zenit-thinking flex-shrink-0 ${className}`} 
      style={{ width: size, height: size }}
    >
      <img 
        src={logoIcon} 
        alt="Thinking..." 
        className="zenit-thinking-img w-full h-full object-contain"
      />
      
      <style>{`
        /* Animación anterior (pulse de opacidad)
        .zenit-thinking {
          animation: zenitPulse 1.5s ease-in-out infinite;
        }
        
        @keyframes zenitPulse {
          0%, 100% {
            opacity: 0.5;
          }
          50% {
            opacity: 1;
          }
        }
        */
        
        /* Animación de cambio morado <-> verde (con invert) */
        .zenit-thinking-img {
          animation: zenitColorSwitch 1s ease-in-out infinite;
        }
        
        @keyframes zenitColorSwitch {
          0%, 100% {
            filter: invert(0); /* morado (original) */
          }
          50% {
            filter: invert(1); /* verde */
          }
        }
        
        /* Animación anterior de cambio de color: negro -> blanco -> morado
        .zenit-thinking-img {
          animation: zenitTriColor 1.5s ease-in-out infinite;
        }
        
        @keyframes zenitTriColor {
          0%, 100% {
            filter: brightness(0);
          }
          33% {
            filter: brightness(0) invert(1);
          }
          66% {
            filter: none;
          }
        }
        */
      `}</style>
    </div>
  );
};

export default ZenitThinking;
